module.exports = __webpack_public_path__ + "img/ic-right.fa48fdba.svg";